import React from "react";
import ReactDOM from "react-dom";
import * as Request from "superagent";
import StepNav from "./components/StepNav";
import RecallVehicle from "./models/RecallVehicle";
import { ApiBasePath } from "./utils/ApiBasePath";
import each from "lodash/each";
import trim from "lodash/trim";
import { PopupModal } from "./components/Modals";
import { PopupModalModel } from "./models/PopupModalModel";
import ReactSelectWrap from "./components/ReactSelectWrap";
import CustomEvent from "custom-event";
import CarDetails from "./models/CarDetails";
import { validateVIN } from "./utils/CarDetailsValidator";

const TakataRecall = (): void => {
  if (!document.querySelector(".takataRecall")) {
    return;
  }
  else {
    window['pushDigitalData']({
      "event": "_pageLoaded"
    });
  }

  const mediaCdnBasePath = window["MediaCdnBasePath"];
  const vinInput = document.getElementById(
    "text-input-vin"
  ) as HTMLInputElement;
  const regoInput = document.getElementById(
    "text-input-rego"
  ) as HTMLInputElement;
  const stateInput = document.getElementById(
    "text-input-state"
  ) as HTMLSelectElement;
  const recaptchaInput = document.getElementById(
    "text-input-recaptcha"
  ) as HTMLInputElement;

  const findCarBtn = document.querySelector(".findCarBtn") as HTMLButtonElement;
  findCarBtn.disabled = true;

  const headingContainer = document.querySelector(".carDetails__heading");
  const makeLabels = document.querySelectorAll(".carDetails__make");
  const modelLabels = document.querySelectorAll(".carDetails__model");
  const yearLabels = document.querySelectorAll(".carDetails__year");
  const badgeLabels = document.querySelectorAll(".carDetails__badge");
  const seriesLabels = document.querySelectorAll(".carDetails__series");
  const transmissionLabels = document.querySelectorAll(
    ".carDetails__transmission"
  );
  const bodyTypeLabels = document.querySelectorAll(".carDetails__bodyType");

  const colourContainer = document.querySelector(".carDetails__colour");
  const colourNameLabel = document.querySelector(".carDetails__colour__name");
  const colourHexLabel = document.querySelector(".carDetails__colour__value");
  const colourDisclaimer = document.querySelector(".carDetails__disclaimer");
  //const vinContainer = document.querySelector(".carDetails__vinContainer");
  //const vinLabels = document.querySelectorAll(".carDetails__vin");
  //const regoContainer = document.querySelector(".carDetails__regoContainer");
  //const regoLabels = document.querySelectorAll(".carDetails__rego");
  const vinRegoLabels = document.querySelectorAll(".carDetails__vinRego");
  const statusLabel = document.querySelector(".carDetails__status");
  const statusMessageLabel = document.querySelector(
    ".carDetails__statusMessage"
  );
  const praNumberLabel = document.querySelector(".carDetails__praNumber");
  const downloadPdfBtn = document.querySelector(".download-pdf");
  const trafficLights = document.querySelector(
    ".carDetails__trafficLights img"
  );
  const silhouette = document.querySelector(".carDetails__silhouette img");
  const buttonsContainer = document.querySelector(".carDetails__buttons");
  const vinError = document.getElementById("vin-error");
  const vinErrorText = document.getElementById("vin-error-text");
  let recallVehicle: RecallVehicle;
  let stateValue: string = "";
  let carDetails: CarDetails;
  let recaptchaToken: string | undefined = undefined;

  const resetStateField = (): void => {
    const evt = new CustomEvent("resetStateField", { detail: {} });
    stateValue = "";
    window.dispatchEvent(evt);
  };

  let vinParam = new RegExp("[?&]vin=([^&#]*)").exec(window.location.href);
  if (vinParam != null) {
    vinInput.value = decodeURI(vinParam[1]);
  }

  const SN = new StepNav();

  const modalContent = document.getElementsByClassName("highlight__modal");
  const modalBtn = document.getElementsByClassName("showModal");

  //Where's my VIN modal
  modalBtn[0].addEventListener("click", (e) => {
    const content: PopupModalModel = { text: modalContent[0].innerHTML };
    const evt = new CustomEvent("showPopupModal", { detail: { content } });
    e.preventDefault();
    window.dispatchEvent(evt);
  });

  //Additional Info modal
  /*
  modalBtn[1].addEventListener("click", e => {
    const content: PopupModalModel = { text: modalContent[1].innerHTML };
    const evt = new CustomEvent("showPopupModal", { detail: { content } });
    e.preventDefault();
    window.dispatchEvent(evt);
  });
  */

  const changeBtns = document.querySelectorAll(".takataRecall__next");
  each(changeBtns, (btn) => {
    btn.addEventListener("click", () => {
      SN.navigate();
    });
  });

  regoInput.addEventListener("input", (e: any) => {
    if (e.target.value) {
      hideAllErrors();
      vinInput.value = "";
      regoInput.value = trim(e.target.value);
    }
  });

  if (stateInput) {
    let states = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"].map(
      (state) => {
        return { value: state, label: state };
      }
    );
    states.unshift({ value: "", label: "State" });

    ReactDOM.render(
      <ReactSelectWrap
        options={states}
        reactSelectProps={{ clearable: false }}
        onChange={(e) => {
          if (e.value) {
            hideAllErrors();
            vinInput.value = "";
            stateValue = e.value;
          }
        }}
      />,
      stateInput
    );
  }

  window["validateRecallRecaptcha"] = (token: string | undefined) => {
    recaptchaToken = token;
    recaptchaInput.value = token;

    if(recaptchaToken) {
      var error = validateVIN(vinInput.value);

      if (!!findCarBtn && !!error || !recaptchaInput.value) {
        findCarBtn.disabled = true;
        vinError.style.display = "block";
        vinErrorText.textContent = error;
      } else {
        findCarBtn.disabled = false;
        vinError.style.display = "none";
        vinErrorText.textContent = "";
      }
    }
  };

  vinInput.addEventListener("input", (e: any) => {
    if (e.target.value) {
      var error = validateVIN(e.target.value);
      if (!!findCarBtn && !!error || !recaptchaInput.value) {
        findCarBtn.disabled = true;
        vinError.style.display = "block";
        vinErrorText.textContent = error;
      } else {
        findCarBtn.disabled = false;
        vinError.style.display = "none";
        vinErrorText.textContent = "";
      }
      hideAllErrors();
      regoInput.value = "";
      resetStateField();
    }
  });

  findCarBtn.addEventListener("click", (e) => {
    e.preventDefault();
    
    if (
      (vinInput.value.length == 0 &&
        regoInput.value.length == 0 &&
        !stateValue) ||
      (regoInput.value.length > 0 && !stateValue) ||
      (regoInput.value.length == 0 && stateValue)
    ) {
      showErrorMessage(400);
    }

    //find car by vin
    if (vinInput.value.length > 0) {
      findCarByVin(vinInput.value, recaptchaToken);
    }
  });

  const confirmCarBtn = document.querySelector(".confirmCarBtn");
  confirmCarBtn.addEventListener("click", () => {
    if (recallVehicle != null) {
      const url = `${ApiBasePath.takataRecall}/${recallVehicle.vinNumber}/statusmessage`;
      Request.get(url).then((response) => {
        if (response.body != null) {
          const messageEl = document.querySelector(".recallMessage__affected");
          messageEl.innerHTML = response.body.message;
          statusLabel.textContent = response.body.status;
          //need to set traffic lights here base on this status.

          let trafficLightColour = "";
          switch (response.body.status) {
            case "FUTURE":
              trafficLightColour = "Amber";
              break;
            case "COMPLETE":
            case "COMPLETED - SALVAGE":
              trafficLightColour = "Green";
              statusLabel.textContent = "COMPLETE";
              break;
            case "ACTIVE":
            case "CRITICAL":
              trafficLightColour = "Red";
              break;
            default:
              trafficLightColour = "Red";
              break;
          }
          trafficLights.setAttribute(
            "src",
            `${mediaCdnBasePath}/takata-recall/${trafficLightColour}.png`
          );
        }
        SN.navigate();
      });
    } else {
      SN.navigate();
    }
  });

  const findCarByVin = (vin, grToken) => {
    if (isSubaru(vin) && !carDetails) {
      const url = `${ApiBasePath.takataRecall}/${vin}`;
      findCar(url);
    } else {
      carNotSubaru();
      SN.navigate();
    }
  };

  const findCar = (url) => {
    Request.get(url).then(
      (response) => {
        if (response.body != null) {
          recallVehicle = response.body;

          carDetails = {
            rego: response.body.registration,
            vin: response.body.vinNumber,
            state: ''
          };

          carAffected(recallVehicle);
          SN.navigate();
        } else {
          carNotAffected();
          SN.navigate();
        }
      },
      (error) => {
        if (error.status == 404) {
          carNotAffected();
          SN.navigate();
        } else {
          showErrorMessage(error.status);
        }
      }
    );
  };

  const isSubaru = (vin) => {
    const subaruPattern = /^(JF1|JF2|4S4)(\w){14}$/i;
    const result = subaruPattern.test(vin);
    return result;
  };

  const getRecallDetails = (recallId) => {
    let url = `${ApiBasePath.takataRecall}/recalls/${recallId}`;

    Request.get(url).then(
      (response) => {
        console.log(response.body);
      },
      (error) => {
        console.log("An error occurred while looking up Recall.");
      }
    );
  };

  const carAffected = (recallVehicle) => {
    let pdfUrl = `/api/takata-recall/${recallVehicle.vinNumber.toUpperCase()}/pdf`;
    if (stateValue) {
      pdfUrl += "?search=registration";
    }

    each(makeLabels, (label) => {
      label.textContent = recallVehicle.vehicleMake;
    });
    each(modelLabels, (label) => {
      label.textContent = recallVehicle.vehicleModel;
    });
    each(yearLabels, (label) => {
      label.textContent =
        "Model Year " + recallVehicle.vehicleMarketingYear.toString();
    });
    each(badgeLabels, (label) => {
      label.textContent = recallVehicle.vehicleBadge;
    });
    each(seriesLabels, (label) => {
      label.textContent = recallVehicle.vehicleSeries;
    });
    each(transmissionLabels, (label) => {
      label.textContent = recallVehicle.vehicleTransmission;
    });
    each(bodyTypeLabels, (label) => {
      label.textContent = recallVehicle.vehicleBodyType;
    });

    each(vinRegoLabels, (label) => {
      if (stateValue) {
        label.textContent = "Registration: " + carDetails.rego.toUpperCase();
      } else {
        label.textContent = "VIN: " + carDetails.vin.toUpperCase();
      }
    });

    colourNameLabel.textContent = recallVehicle.vehicleColourName;

    if (recallVehicle.vehicleColourHex != null) {
      colourHexLabel.setAttribute(
        "style",
        `background-color: #${recallVehicle.vehicleColourHex}`
      );
    } else {
      colourHexLabel.classList.add("hidden");
    }

    // statusLabel.textContent = recallVehicle.status;
    praNumberLabel.textContent = recallVehicle.praNumber;
    statusMessageLabel.textContent =
      "This vehicle is included in the Takata airbag inflator recall. If this is your vehicle, please continue to Step 3 to confirm the current recall status of your Subaru vehicle.";

    const recallDetails = document.querySelector(".recallDetails");
    recallDetails.classList.add("recallDetails--affected");

    downloadPdfBtn.setAttribute("href", pdfUrl);
    silhouette.setAttribute("src", getSilhouetteUrl(recallVehicle));
  };

  const carNotSubaru = () => {
    each(vinRegoLabels, (label) => {
      label.classList.add("hidden");
    });

    statusMessageLabel.innerHTML =
      "<p>We have no record of this VIN/registration number in our system. " +
      "Please double check the VIN (Vehicle Identification Number) or registration number and state/territory entered.</p>" +
      "<p>If this vehicle is not a Subaru vehicle, please visit the Australian website of the relevant manufacturer.</p>" +
      "<p>If this vehicle is a Subaru vehicle, it may have been imported into Australia by a third party. " +
      "In this case please contact our dedicated Recall Contact Centre on <strong>1300 550 994</strong> or email " +
      "<a href='mailto:feedback@subaru.com.au'>feedback@subaru.com.au</a>.</p>";

    const recallDetails = document.querySelector(".recallDetails");
    recallDetails.classList.add("recallDetails--notSubaru");

    colourContainer.classList.add("hidden");
    colourDisclaimer.classList.add("hidden");
    downloadPdfBtn.classList.add("hidden");
    buttonsContainer.classList.add("hidden");
    headingContainer.textContent = "Vehicle Not Found";

    trafficLights.setAttribute(
      "src",
      mediaCdnBasePath + "/takata-recall/Amber.png"
    );
  };

  const carNotAffected = () => {
    each(vinRegoLabels, (label) => {
      if (stateValue) {
        label.textContent = "Registration: " + (regoInput.value || "Unknown");
      } else {
        label.textContent = "VIN: " + (vinInput.value || "Unknown");
      }
    });

    statusMessageLabel.innerHTML =
      "<p>The Subaru VIN/registration number you entered is <strong>not</strong> affected by the Takata airbag inflator recall. " +
      "Please <a href='https://www.subaru.com.au/recall'>click here</a> to check if this Subaru vehicle has been subject to any other recalls. </p>" +
      "<p>If you have any questions relating to Subaru Australia initiated recalls, please contact our dedicated Recall Contact Centre on <strong>1300 550 994</strong> or email " +
      "<a href='mailto:feedback@subaru.com.au'>feedback@subaru.com.au</a>.</p>";

    const recallDetails = document.querySelector(".recallDetails");
    recallDetails.classList.add("recallDetails--notAffected");

    colourContainer.classList.add("hidden");
    colourDisclaimer.classList.add("hidden");
    downloadPdfBtn.classList.add("hidden");

    trafficLights.setAttribute(
      "src",
      mediaCdnBasePath + "/takata-recall/Green.png"
    );
  };

  const getSilhouetteUrl = (recallVehicle) => {
    try {
      // "model-buildyear-bodytype.png"
      var root = mediaCdnBasePath + "/takata-recall/silhouettes";
      var model = recallVehicle.vehicleModel.toLowerCase().replace(/\s/g, "");
      var series = recallVehicle.vehicleSeries.toLowerCase();
      var year = recallVehicle.vehicleMarketingYear.toString();
      var bodyType = recallVehicle.vehicleBodyType.toString().toLowerCase();

      // wrx and wrx sti have a model valule of impreza.
      // We need to interogate the series to identify if it is a wrx or sti.
      if (model == "impreza") {
        if (series.includes("sti")) {
          // is an sti
          model = "impreza-wrx-sti";
        } else if (series.includes("4wx") || series.includes("wrx")) {
          // is a wrx
          model = "impreza-wrx";
        }
      }

      return `${root}/${model}-${year}-${bodyType}.jpg`;
    } catch (e) {
      return `${root}/unknown.png`;
    }
  };

  const showErrorMessage = (statusCode) => {
    hideAllErrors();
    document
      .querySelector(`.alert-code-${statusCode}`)
      .classList.remove("hidden");
  };

  const hideAllErrors = () => {
    const errors = document.querySelectorAll(".alert");
    each(errors, (error) => {
      error.classList.add("hidden");
    });
  };

  //Modal Popup
  const popupModal = document.createElement("div");
  if (popupModal) {
    document.body.appendChild(popupModal);
    ReactDOM.render(<PopupModal />, popupModal);
  }

  //StepNav Change
  SN.beforeChange = (step: number) => {};

  SN.onChangeComplete = (step: number) => {
    switch (step) {
      case 1:
        break;
    }
    window['pushDigitalData']({
      "event": "_formNavigate",
      "form": {
          "name": SN.groupTitle,
          "stage": (SN.scope.querySelector("li.is-active span")).textContent
      },
    }, true);
  };
};

TakataRecall();
